import request from '../utils/Request';

const baseURL = 'masterdata';

const masterDataService = {
  typeToForm: (subMenuId) => {
    return request({
      resource: `${baseURL}/type/${encodeURIComponent(subMenuId)}`,
    });
  },

  statusToForm: (subMenuId) => {
    return request({
      resource: `${baseURL}/status/${encodeURIComponent(subMenuId)}`,
    });
  },

  priorityToForm: (subMenuId) => {
    return request({
      resource: `${baseURL}/priority/${encodeURIComponent(subMenuId)}`,
    });
  },

  groupToForm: (subMenuId) => {
    return request({
      resource: `${baseURL}/projectgroup/${encodeURIComponent(subMenuId)}`,
    });
  },

  classificationToForm: (subMenuId) => {
    return request({
      resource: `${baseURL}/classification/${encodeURIComponent(subMenuId)}`,
    });
  },

  companyToForm: () => {
    return request({
      resource: `${baseURL}/companies`,
    });
  },

  projectToForm: () => {
    return request({
      resource: `${baseURL}/projects`,
    });
  },

  usersToForm: () => {
    return request({
      resource: `${baseURL}/users`,
    });
  },

  resourceOneToForm: () => {
    return request({
      resource: `${baseURL}/resourceOne`,
    });
  },

  operationToForm: () => {
    return request({
      resource: `${baseURL}/operations`,
    });
  },

  quantityUnitToForm: () => {
    return request({
      resource: `${baseURL}/quantityUnits`,
    });
  },

  formTypeSubmenus: () => {
    return request({
      resource: `${baseURL}/formTypeSubmenus`,
    });
  },

  provinceToForm: () => {
    return request({
      resource: `${baseURL}/provinces`,
    });
  },

  resourceTwoToForm: () => {
    return request({
      resource: `${baseURL}/resourceTwo`,
    });
  },

  resourceThreeToForm: () => {
    return request({
      resource: `${baseURL}/resourceThree`,
    });
  },

  resourceFourToForm: () => {
    return request({
      resource: `${baseURL}/resourceFour`,
    });
  },

  resourceFiveToForm: () => {
    return request({
      resource: `${baseURL}/resourceFive`,
    });
  },

  bussinessPartnersToForm: () => {
    return request({
      resource: `${baseURL}/bussinessPartners`,
    });
  },

  supplierPartnersToForm: () => {
    return request({
      resource: `${baseURL}/supplierPartners`,
    });
  },

  itemsToForm: () => {
    return request({
      resource: `${baseURL}/items`,
    });
  },

  itemsFromTableToForm: () => {
    return request({
      resource: `${baseURL}/itemsFromTable`,
    });
  },

  itemsFromTableToFormByItemCode: (itemCode) => {
    return request({
      resource: `${baseURL}/itemsFromTable/${encodeURIComponent(itemCode)}`,
    });
  },

  companyLocationToForm: () => {
    return request({
      resource: `${baseURL}/companylocation`,
    });
  },

  crmEventsToForm: () => {
    return request({
      resource: `${baseURL}/crmEvents`,
    });
  },

  vatToForm: () => {
    return request({
      resource: `${baseURL}/vat`,
    });
  },

  taskListTemplatesToForm: () => {
    return request({
      resource: `${baseURL}/taskListTemplates`,
    });
  },

  currencyToForm: () => {
    return request({
      resource: `${baseURL}/currency`,
    });
  },

  priceListToForm: () => {
    return request({
      resource: `${baseURL}/priceList`,
    });
  },

  warehouseToForm: () => {
    return request({
      resource: `${baseURL}/warehouse`,
    });
  },

  vatCodeToForm: () => {
    return request({
      resource: `${baseURL}/vatCode`,
    });
  },

  paymentMethodToForm: () => {
    return request({
      resource: `${baseURL}/paymentMethod`,
    });
  },

  countryToForm: () => {
    return request({
      resource: `${baseURL}/country`,
    });
  },

  kshClassificationToForm: () => {
    return request({
      resource: `${baseURL}/kshClassification`,
    });
  },

  itemGroupToForm: () => {
    return request({
      resource: `${baseURL}/itemGroup`,
    });
  },

  companyGroupToForm: () => {
    return request({
      resource: `${baseURL}/companyGroup`,
    });
  },

  languageToForm: () => {
    return request({
      resource: `${baseURL}/language`,
    });
  },

  incotermToForm: () => {
    return request({
      resource: `${baseURL}/incoterm`,
    });
  },

  salesOrPurchasePersonToForm: () => {
    return request({
      resource: `${baseURL}/salesOrPurchasePerson`,
    });
  },

  deliveryMethodToForm: () => {
    return request({
      resource: `${baseURL}/deliveryMethod`,
    });
  },

  costCenterToForm: () => {
    return request({
      resource: `${baseURL}/costCenter`,
    });
  },

  operationGroupToForm: () => {
    return request({
      resource: `${baseURL}/operationGroups`,
    });
  },

  productionStatusToForm: () => {
    return request({
      resource: `${baseURL}/productionStatus`,
    });
  },

  groupReportingToForm: (operationId, resourceOneId) => {
    return request({
      resource: `${baseURL}/groupReporting/${encodeURIComponent(operationId)}/${encodeURIComponent(resourceOneId)}`,
    });
  },

  templateItemsToForm: () => {
    return request({
      resource: `${baseURL}/templateItems`,
    });
  },

  roleListsToForm: () => {
    return request({
      resource: `${baseURL}/roleLists`,
    });
  },

  roleListsByRoleId: (roleId) => {
    return request({
      resource: `${baseURL}/roleLists/${encodeURIComponent(roleId)}`,
    });
  },

  interruptionReasonsToForm: () => {
    return request({
      resource: `${baseURL}/interruptionReasons`,
    });
  },

  downTimeReasonsToForm: () => {
    return request({
      resource: `${baseURL}/downtimeReasons`,
    });
  },

  userGroupsToForm: () => {
    return request({
      resource: `${baseURL}/userGroups`,
    });
  },

  favouriteMenusToForm: (userId) => {
    return request({
      resource: `${baseURL}/favouriteMenus/${encodeURIComponent(userId)}`,
    });
  },

  dashboardsToForm: () => {
    return request({
      resource: `${baseURL}/dashboards`,
    });
  },

  biReportsToForm: () => {
    return request({
      resource: `${baseURL}/biReports`,
    });
  },

  scrapReasonsToForm: () => {
    return request({
      resource: `${baseURL}/scrapReasons`,
    });
  },

  costAndRevenueToForm: () => {
    return request({
      resource: `${baseURL}/costAndRevenues`,
    });
  },

  rolesToForm: () => {
    return request({
      resource: `${baseURL}/roles`,
    });
  },

  webUserArchiveToForm: () => {
    return request({
      resource: `${baseURL}/webUserArchive`,
    });
  },

  getDynamicFroms: () => {
    return request({
      resource: `${baseURL}/dynamicForms`,
    });
  },

  getQNTResources: () => {
    return request({
      resource: `${baseURL}/qntresources`,
    });
  },

  settlementModeToForm: () => {
    return request({
      resource: `${baseURL}/settlementMode`,
    });
  },

  projectTypeToForm: () => {
    return request({
      resource: `${baseURL}/projectType`,
    });
  },

  homePageProjectTypeToForm: () => {
    return request({
      resource: `${baseURL}/homePageProjectType`,
    });
  },

  serviceTaskTypeToForm: () => {
    return request({
      resource: `${baseURL}/serviceTaskType`,
    });
  },

  serviceGroupForm: () => {
    return request({
      resource: `${baseURL}/serviceGroup`,
    });
  },

  serviceStatusToForm: () => {
    return request({
      resource: `${baseURL}/serviceStatus`,
    });
  },

  workAreaToForm: () => {
    return request({
      resource: `${baseURL}/workArea`,
    });
  },

  serviceOperationToForm: () => {
    return request({
      resource: `${baseURL}/serviceOperation`,
    });
  },

  complaintStatusToForm: () => {
    return request({
      resource: `${baseURL}/complaintstatus`,
    });
  },

  complaintTypeToForm: () => {
    return request({
      resource: `${baseURL}/complainttype`,
    });
  },

  complaintReasonToForm: () => {
    return request({
      resource: `${baseURL}/complaintreason`,
    });
  },

  complaintResolutionRequestToForm: () => {
    return request({
      resource: `${baseURL}/complaintresolutionrequest`,
    });
  },

  complaintResolutionToForm: () => {
    return request({
      resource: `${baseURL}/complaintresolution`,
    });
  },

  complaintActionTakenToForm: () => {
    return request({
      resource: `${baseURL}/complaintactiontaken`,
    });
  },

  complaintToForm: () => {
    return request({
      resource: `${baseURL}/complaint`,
    });
  },

  complaintEffectToForm: () => {
    return request({
      resource: `${baseURL}/complainteffect`,
    });
  },

  companyToFormById: (id) => {
    return request({
      resource: `${baseURL}/company/${encodeURIComponent(id)}`,
    });
  },

  itemsByGroupId: (itemGroupId) => {
    return request({
      resource: `${baseURL}/items/${encodeURIComponent(itemGroupId)}`,
    });
  },

  planTaskToForm: () => {
    return request({
      resource: `${baseURL}/planTasks`,
    });
  },

  responsibleList() {
    return request({
      resource: `${baseURL}/responsibleList`,
    });
  },
};

export default masterDataService;
